
const lastUpdate = '2026-03-15';
export const helpTitle = 'Fire Modeling';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Fire Modeling tool creates fire spread models using Project Nomad. Models show predicted fire perimeters and spread probability as map layers.</p>

<h2>Creating a Model</h2>
<ol>
  <li><strong>Draw the ignition</strong> — Click on the map to place an ignition point, or draw a polygon to define an ignition area.</li>
  <li><strong>Configure parameters</strong> — Set the output mode and confidence interval for the model run.</li>
  <li><strong>Run the model</strong> — Submit the model. Processing time varies based on complexity.</li>
</ol>

<h2>Viewing Results</h2>
<p>When the model completes, results appear as map layers:</p>
<ul>
  <li><strong>Perimeters</strong> — Predicted fire boundaries at selected time steps.</li>
  <li><strong>Raster Probability</strong> — A heat map showing the probability of fire reaching each location.</li>
</ul>
<p>Toggle individual result layers on and off using the Layer Drawer.</p>

<h2>Clearing the Map</h2>
<p>Click <strong>Clear Map</strong> to remove all fire model layers from the map. This does not delete the model — it only removes the visual display.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
